export default "__VITE_ASSET__DLzUnswE__"